import { Button } from '@mui/material';
import { CleanButtonProps } from './type';
import palette from '../../themes/styles/palette';

const CleanButton: React.FC<CleanButtonProps> = ({ label, Icon, onClick }) => {
  return (
    <Button
      variant="contained" // or outlined, text as per your design
      color="primary" // or default, inherit, secondary as per your design
      style={{ border: `1px solid ${palette['primary'].darker}` }}
      fullWidth
      startIcon={<Icon />}  // or replace <Icon /> with <SaveIcon /> if you always want to use the save icon
      onClick={onClick}
    >
      {label}
    </Button>
  );
}

export default CleanButton;
